module.exports = __webpack_public_path__ + "static/media/close.061aa6f6.svg";